import ParamManage from './ParamManage.vue'

ParamManage.install = function (Vue) {
    Vue.component(ParamManage.name, ParamManage)
}

import ParamEdit from './ParamEdit.vue'

ParamEdit.install = function (Vue) {
    Vue.component(ParamEdit.name, ParamEdit)
}

export {ParamManage, ParamEdit}
